module.exports = __webpack_public_path__ + "static/img/10002.5385e2b7.png";